module.exports = __webpack_public_path__ + "img/w3_cykel_white.27ebf08b.png";